const url = `http://46.101.204.118:3000/random-word`;

export const state = {
  loadedWord: [],
  player:{
    wordEntered:[],
    indexOfLetter:[],
    truePosition:[],
    win:false,
    guessNum:0
  }
}



export const loadWords = async function () {
  try {

    const data = await fetch(url);


    //if (!data.ok || (!data)) throw new Error('reqquest is not vaild')
    // let word = (await data.json())[0];
let word = await data.json();
console.log(word);

   // if (!word) throw new Error("the word you looking for does not exist");


    const wordArr = word.word.split('');
    console.log(wordArr);
    
    state.loadedWord = wordArr;

    console.log(state);

    return word;


  } catch (error) {
    console.log('server is down', error);

  }




}

export const check = function (wordEntered, wordToCompare) {
  try {
    
    state.player.guessNum =state.player.guessNum+1;
    //checks the number of letters if its match
    if (wordEntered.length != wordToCompare.length) throw new Error('word size is not correct')
    //checks each letter
    state.player.wordEntered = wordEntered;
    const resultArr = wordEntered.map(element => {
      if (wordToCompare.includes(element)) {

        return true;
      } else {
        return false

      }
    });
    console.log('resuilt array',resultArr);
    
 state.player.resultArr = resultArr;


    let indexOfLetter = resultArr.map((el, index) => {
      if (el === true) {
        return index
      }
    });
     state.player.indexOfLetter = indexOfLetter;
 
   console.log(indexOfLetter);

    //check position of true letter
    let i = 0;
    while (i < wordToCompare.length) {
     
      
      if (wordEntered[i] === wordToCompare[i]) {

       state.player.truePosition.push(i)
        if(state.player.truePosition.length === wordToCompare.length){
          state.player.win =true
        }
      }
      i++;
    }



  } catch (error) {
    console.log(error);

  }

}

//check(['e','d','y'],['g','g','e'])


